<div class="detail-card" fxLayout="column" fxLayoutGap="4px">
  <ul class="detail-card-list">
    <li attr.data-label="{{ 'DETAIL_DEVICE_VARIABLE_CARD_COMPONENT.NAME' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(event()?.context?.device?.name) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_DEVICE_VARIABLE_CARD_COMPONENT.TYPE' | translate }}" class="detail-card-item">
      {{
        {
          family: $safeNavigationMigration(event()?.context?.device?.family),
          model: $safeNavigationMigration(event()?.context?.device?.model)
        } | infoDisplay: 'hyphen' : 'family' : 'model'
      }}
    </li>
    <li attr.data-label="{{ 'DETAIL_DEVICE_VARIABLE_CARD_COMPONENT.VARIABLE' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(event()?.context?.deviceVariable?.name) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_DEVICE_VARIABLE_CARD_COMPONENT.EVENT_VALUE' | translate }}" class="detail-card-item">
      <span> {{ computedContextVariable() | valueUnitFormat }}</span>
      @if (event()?.context?.deviceVariable?.value) {
        &nbsp;<span>({{ $safeNavigationMigration(event()?.occurrenceTime) | dateFormat }})</span>
      }
    </li>
    <li attr.data-label="{{ 'DETAIL_DEVICE_VARIABLE_CARD_COMPONENT.COMMENT' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(event()?.context?.deviceVariable?.comment) | infoDisplay }}
    </li>
  </ul>
  <ul class="detail-card-list">
    <li attr.data-label="{{ 'DETAIL_DEVICE_VARIABLE_CARD_COMPONENT.CURRENT_VALUE' | translate }}" class="detail-card-item">
      @if (event()?.context?.deviceVariable.id && currentDeviceVariable() === undefined) {
        <iot-platform-ui-card-loader [backgroundClass]="'users-detail-bp'" />
      } @else if (!!currentDeviceVariable()) {
        <span class="device-variable-card-value"> {{ currentDeviceVariable() | valueUnitFormat }} </span>
        <span>({{ $safeNavigationMigration(currentDeviceVariable()?.lastValue?.datetime) | dateFormat | infoDisplay }})</span>
      } @else {
        <span>-</span>
      }
    </li>
  </ul>
</div>
